const Sticky = require('sticky-js');
const stickyHeader = new Sticky('.header__content', {
  stickyClass: 'sticky',
});

document.querySelector('.header__nav').addEventListener('click', (evt) => {
  document.documentElement.classList.toggle('nav--opened');
});
